import * as React from 'react';
import { Trash2 } from 'lucide-react';
import { SetupLoader } from 'core/components/SetupComponents/SetupLoader';
import { Modal } from './ui/Modal';
import { DMButton, DMDiv, DMText } from './Primitives';

type DigitalMarketingDeleteModalProps = {
  isOpen: boolean;
  title?: string;
  description?: string;
  isDeleting?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function DigitalMarketingDeleteModal({
  isOpen,
  title = 'Are you sure you want to delete this item?',
  description = 'This action cannot be undone, and your details will be removed from the school website.',
  isDeleting = false,
  onCancel,
  onConfirm,
}: DigitalMarketingDeleteModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onCancel} className="z-[10050]">
      <DMDiv className="flex flex-col items-center py-4">
        <DMDiv className="mb-6 flex h-20 w-20 items-center justify-center rounded-2xl bg-[#E83934]">
          <Trash2 size={40} className="text-white" />
        </DMDiv>
        <DMText as="h2" className="mb-2 text-2xl font-bold text-gray-900">
          {title}
        </DMText>
        <DMText className="mb-8 text-gray-500">{description}</DMText>
        <DMDiv className="flex w-full gap-4">
          <DMButton
            type="button"
            onClick={onCancel}
            disabled={isDeleting}
            className="flex-1 rounded-full bg-gray-100 py-3 font-medium text-gray-900 transition-colors hover:bg-gray-200 disabled:cursor-not-allowed disabled:opacity-50"
          >
            Cancel
          </DMButton>
          <DMButton
            type="button"
            onClick={onConfirm}
            disabled={isDeleting}
            className="flex flex-1 items-center justify-center rounded-full bg-[#5E4DE0] py-3 font-medium text-white transition-colors hover:bg-[#4638C0] disabled:cursor-not-allowed disabled:opacity-50"
          >
            {isDeleting ? (
              <DMDiv className="flex items-center justify-center rounded-full bg-white p-1">
                <SetupLoader height="h-5" />
              </DMDiv>
            ) : (
              'Yes'
            )}
          </DMButton>
        </DMDiv>
      </DMDiv>
    </Modal>
  );
}
